import {
  CreateRewardDto,
  DeleteRewardDto,
  EarnRewardDto,
  EditRewardDto,
  GetRewardCampaignDto,
  GetRewardDto,
  ManualUpgradeDto,
  MembersDto,
  MessageResponseDto,
  RedeemRewardDto,
  RewardApiFp,
  RewardControllerCampaign200Response,
  RewardControllerGet200Response,
  RewardControllerMembers200Response,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseCampaignRewardModel =
  RewardControllerCampaign200Response;
export type GetResponseRewardModel = RewardControllerGet200Response;
export type GetResponseRewardCampaignModel =
  RewardControllerCampaign200Response;
export type GetResponseRewardMemberModel = RewardControllerMembers200Response;
export type GetRewardModel = GetRewardDto;
export type MutateResponseRewardModel = MessageResponseDto;
export type CreateRewardModel = CreateRewardDto;
export type UpdateRewardModel = EditRewardDto;
export type DeleteRewardModel = DeleteRewardDto;
export type EarnRewardModel = EarnRewardDto;
export type RedeemRewardModel = RedeemRewardDto;
export type GetRewardCampaignModel = GetRewardCampaignDto;
export type RewardMemberModel = MembersDto;
export type ManualUpgradeModel = ManualUpgradeDto;

export const apiRewardFp = RewardApiFp(apiConfig);
export const getRewardController = apiRewardFp.rewardControllerGet;
export const createRewardController = apiRewardFp.rewardControllerCreate;
export const updateRewardController = apiRewardFp.rewardControllerEdit;
export const deleteRewardController = apiRewardFp.rewardControllerDelete;
export const getRewardBalanceController = apiRewardFp.rewardControllerBalance;
export const earnRewardController = apiRewardFp.rewardControllerEarn;
export const showConversionController = apiRewardFp.rewardControllerShowConversion;
export const redeemRewardController = apiRewardFp.rewardControllerRedeem;
export const getCampaignRewardController = apiRewardFp.rewardControllerCampaign;
export const getMembersRewardController = apiRewardFp.rewardControllerMembers;
export const getUserBalanceRewardController =
  apiRewardFp.rewardControllerUserBalance;
export const redeemV2RewardController = apiRewardFp.rewardControllerRedeemV2;
export const getRewardCampaignController = apiRewardFp.rewardControllerCampaign;
export const manualUpgradeController = apiRewardFp.rewardControllerManualUpgrade;

export const QueryKeyReward = QueryKey.Reward;

export interface GetRewardPayload {
  code: string;
  tenant: string;
}
export interface RewardBalance {
  code: string;
  card_alias: string;
  user_code: string;
  activation_date: string; // ISO date string
  expiration_date: string; // ISO date string
  is_blocked: number; // 0 or 1
  is_lost: number; // 0 or 1
  is_stolen: number; // 0 or 1
  remarks: string | null;
  card_category: string;
  card_category_name: string;
  first_name: string;
  last_name: string;
  total_points: number;
  total_stamp: string;
  total_redeem_points: number;
  total_redeem_stamp: string;
  current_points: number;
  current_stamp: number;
  level: string;
  level_name: string;
  level_description: string;
  level_avatar: string;
  level_points_cap: number;
  level_stamp_cap: number;
  level_constraint: "AND" | "OR";
  exp_points: number;
  exp_stamp: string;
  next_level: string;
  next_level_name: string;
  next_level_description: string;
  next_level_avatar: string;
  next_level_points_cap: number;
  next_level_stamp_cap: number;
  next_level_constraint: "AND" | "OR";
}
export interface EarnResponse {
  tenant: string;
  branch: string;
  user_code: string;
  card_series: string;
  reward: string;
  action: "EARN"; // can be string literal if it's always "EARN"
  amount: number;
  points: number;
  stamp: number;
  code: string;
  created_at: string; // ISO date string
  created_by: string;
  updated_at: string; // ISO date string
  updated_by: string;
  deleted_at: string | null;
  deleted_by: string | null;
  campaign: string | null;
  remarks: string | null;
  is_active: boolean;
  id: number;
}

export interface UserBalanceResponse {
  card_alias: string;
  card_category: string;
  card_category_description: string;
  card_category_name: string;
  card_current_points: number;
  card_current_stamp: string;
  card_series: string;
  card_total_points: number;
  card_total_redeem_points: number;
  card_total_redeem_stamp: string;
  card_total_stamp: string;
  first_name: string;
  is_merged_points: number;
  is_merged_stamp: number;
  last_name: string;
  nickname: string;
  tenant: string;
  user_code: string;
  user_current_points: number;
  user_current_stamp: string;
  user_total_points: number;
  user_total_redeem_points: number;
  user_total_redeem_stamp: string;
  user_total_stamp: string;
}
